import { cn } from '@/shadcn-ui/utils';
import SortSelect from './sort-select';
import { useSearchParams } from 'react-router';

interface TotalSortSubHeaderProps {
  total?: number;
}

export default function TotalSortSubHeader({ total }: TotalSortSubHeaderProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <>
      <div
        className={cn('flex w-full items-center justify-between', {
          'justify-end': total === undefined,
        })}
      >
        {total !== undefined ? <p className="body2">{total} results</p> : null}
        <SortSelect
          disabled={!total}
          sortValue={searchParams.get('sort_option') || 'popular'}
          setSortValue={(value) => {
            setSearchParams((prev) => {
              prev.set('sort_option', value);
              return prev;
            });
          }}
          sortTriggerConfiguration={{
            chevronFill: 'fill-flexcar-neutral1',
            classNameText: 'text-flexcar-neutral1',
          }}
        />
      </div>
    </>
  );
}
